import Svg, { Path } from '@rd-core-svg/svg'
import type { LogoSvgProps } from '../svg.types'

export const UniversLightBlue = (props: LogoSvgProps) => {
  return (
    <Svg {...props} viewBox="0 0 349 80" fill="none">
      <Path
        d="M231.082 18.2676H219.83L204.571 61.7324H214.743C214.743 61.7324 226.066 36.7444 231.082 18.2676Z"
        fill="#FFF"
      />
      <Path
        d="M106.398 43.5966C106.398 46.4943 105.596 48.7442 103.994 50.3465C102.391 51.9828 100.266 52.801 97.6184 52.801C94.9708 52.801 92.9153 51.9828 91.3128 50.3465C89.7102 48.7102 88.909 46.4602 88.909 43.6307V18.0291H78.3879V43.6307C78.3879 47.2443 79.2241 50.4828 80.8614 53.2782C82.4988 56.1077 84.7981 58.2895 87.6897 59.8235C90.616 61.3576 93.9256 62.1416 97.6184 62.1416C101.311 62.1416 104.516 61.3235 107.443 59.7212C110.369 58.119 112.668 55.9032 114.341 53.0737C116.013 50.2442 116.849 47.0738 116.849 43.5285V17.9609H106.363V43.5626L106.398 43.5966Z"
        fill="#006F83"
      />
      <Path
        d="M152.836 43.0851L133.815 18.2676H124.827V61.7324H135.313V36.8807L154.404 61.7324H163.322V18.2676H152.836V43.0851Z"
        fill="#006F83"
      />
      <Path
        d="M182.553 18.2676H172.067V61.7324H182.553V18.2676Z"
        fill="#006F83"
      />
      <Path
        d="M246.237 44.1419H263.168V35.0399H246.237V27.5401H265.084V18.2676H235.75V61.7324H265.711V52.3917H246.237V44.1419Z"
        fill="#FFF"
      />
      <Path
        d="M305.043 39.8807C306.645 37.6307 307.447 35.1081 307.447 32.2786C307.447 29.4491 306.785 27.2673 305.426 25.1538C304.102 23.0402 302.117 21.3357 299.539 20.1084C296.926 18.8812 293.825 18.2676 290.237 18.2676H272.713V61.7324H283.2V46.5623H287.171C289.296 48.71 291.247 51.0622 293.059 53.653C294.835 56.2439 296.368 58.937 297.622 61.7324H309.99C307.063 55.1871 303.231 49.5963 298.563 44.9601C301.315 43.801 303.51 42.1306 305.113 39.8807H305.043ZM295.114 36.8126C293.999 37.8353 292.362 38.3466 290.202 38.3466H283.165V26.7901H290.202C292.397 26.7901 294.034 27.3014 295.149 28.3582C296.264 29.415 296.821 30.8127 296.821 32.5854C296.821 34.3581 296.264 35.7899 295.114 36.8126Z"
        fill="#FFF"
      />
      <Path
        d="M343.539 40.8011C341.553 38.8921 338.348 37.3239 333.958 36.0285L328.175 34.3581C325.319 33.574 323.89 32.2786 323.89 30.4718C323.89 28.6651 324.517 28.1878 325.806 27.506C327.095 26.8583 328.872 26.5174 331.171 26.5174C333.471 26.5174 335.108 26.756 337.233 27.2333C339.358 27.7105 341.379 28.4264 343.365 29.415V20.313C339.602 18.6085 335.421 17.7222 330.858 17.7222C326.294 17.7222 324.448 18.3017 321.8 19.4267C319.152 20.5857 317.097 22.188 315.599 24.2675C314.101 26.347 313.369 28.6992 313.369 31.29C313.369 33.8808 314.379 37.1876 316.435 39.0966C318.49 41.0398 321.486 42.5738 325.493 43.6988L331.345 45.3692C333.053 45.8465 334.272 46.426 334.969 47.0396C335.665 47.6532 336.014 48.4714 336.014 49.4941C336.014 50.5168 335.421 51.6077 334.202 52.2554C332.983 52.9031 331.345 53.244 329.255 53.244C323.925 53.244 318.943 52.1872 314.31 50.1077V59.3802C318.664 61.2211 323.716 62.1415 329.499 62.1415C335.282 62.1415 335.874 61.562 338.452 60.3688C341.03 59.1757 343.016 57.5734 344.41 55.528C345.803 53.4826 346.5 51.1986 346.5 48.6418C346.5 46.0851 345.49 42.642 343.504 40.7329L343.539 40.8011Z"
        fill="#FFF"
      />
      <Path
        d="M187.256 18.2676H198.509L213.768 61.7324H203.595C203.595 61.7324 192.273 36.7444 187.256 18.2676Z"
        fill="#006F83"
      />
      <Path
        d="M64.965 41.5512L48.8897 42.4716C41.5703 42.8466 37.3634 47.1079 36.9871 54.4031L36.0637 70.4254C35.9952 72.0277 37.5002 72.539 38.7315 71.2777L65.7859 44.2102C67.0172 42.9148 66.5383 41.483 64.9308 41.5512H64.965Z"
        fill="#FFF"
      />
      <Path
        d="M38.7315 8.72239C37.5002 7.42697 35.9952 7.97241 36.0637 9.57464L36.9871 25.597C37.3634 32.8922 41.5703 37.1535 48.8897 37.5285L64.965 38.4489C66.5725 38.5171 67.0172 37.0853 65.8201 35.7899L38.7657 8.72239H38.7315Z"
        fill="#FFF"
      />
      <Path
        d="M32.0277 54.403C31.6515 47.1078 27.4445 42.8465 20.1251 42.4715L4.04984 41.5511C2.44231 41.4829 1.99768 42.9829 3.19477 44.2101L30.2492 71.2776C31.4805 72.573 32.9854 72.0276 32.917 70.4253L31.9935 54.403H32.0277Z"
        fill="#FFF"
      />
      <Path
        d="M30.2493 8.72213L3.19488 35.7896C1.96358 37.0169 2.44242 38.5168 4.04995 38.4486L20.1252 37.5282C27.4446 37.1532 31.6516 32.892 32.0278 25.5967L32.9513 9.57438C33.0197 7.97215 31.5148 7.4608 30.2835 8.72213H30.2493Z"
        fill="#FFF"
      />
    </Svg>
  )
}
